import { defineComponent as a, ref as n, onMounted as m, createElementBlock as p, openBlock as u } from "vue";
import { createObserver as f } from "../../../utils/intersectionObserver.js";
const _ = /* @__PURE__ */ a({
  __name: "ListItemPlaceholder",
  props: {
    listboxElement: {}
  },
  emits: ["intersect"],
  setup(l, { emit: s }) {
    const c = l, i = s, e = n(void 0), t = n(null);
    return m(() => {
      e.value = f({
        $el: t.value,
        autoUnobserve: !1,
        callback: (o) => {
          const { isIntersecting: r } = o[0];
          r && (e.value?.disconnect(), i("intersect"));
        },
        options: {
          root: c.listboxElement,
          rootMargin: "70px",
          threshold: 0.25
        }
      });
    }), (o, r) => (u(), p("li", {
      ref_key: "placeholderItem",
      ref: t
    }, null, 512));
  }
});
export {
  _ as default
};
